<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>自动问答</el-breadcrumb-item>
      <el-breadcrumb-item>自动问答管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-select v-model="keywords.scene" placeholder="请选择" class="select"  style="width: 200px;">
              <el-option label="请选择场景" value="0"></el-option>
              <el-option label="江苏睿世力" value="1"></el-option>
              <el-option label="广州睿眼" value="2"></el-option>
              <el-option label="豆迈科技" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.question" placeholder="请输入问题"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.labels" placeholder="请输入标签"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="success" @click="clickmuban">下载导入模板</el-button>
            <TencentyunCosUploadExcel @change="changeTencentyunCosUploadExcel"></TencentyunCosUploadExcel>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Scenes" label="场景" min-width="10%"></el-table-column>
          <el-table-column prop="Question" label="问题" min-width="20%"></el-table-column>
          <el-table-column prop="Answerfile" label="答复文字/图片/视频" min-width="35%"></el-table-column>
          <el-table-column prop="Labels" label="标签" min-width="15%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="10%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="10%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickedit(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="添加自动问答" name="three">
      <el-form :model="myForm" ref="myForm" label-width="170px">
        <el-form-item label="场景" class="addAdminForm">
          <el-select v-model="myForm.scene" placeholder="请选择" class="select"  style="width: 200px;">
            <el-option label="江苏睿世力" value="1"></el-option>
            <el-option label="广州睿眼" value="2"></el-option>
            <el-option label="豆迈科技" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问题" class="addAdminForm">
          <el-input v-model="myForm.question"></el-input>
        </el-form-item>
        <el-form-item label="答复-文字/图片/视频" class="addAdminForm">
          <el-input v-model="myForm.answerfilesub"></el-input>
          <el-button type="text" @click="clickAddSub()">增加</el-button>
          <li v-for="item,index in myForm.answerfile" :key="index">
            答复：{{item.v}}
            <el-button type="text" @click="clickDeleteSub(index)">删除</el-button>
          </li>
        </el-form-item>
        <el-form-item label="标签" class="addAdminForm">
          <el-input v-model="myForm.labelssub"></el-input>
          <el-button type="text" @click="clickAddLabelsSub()">增加</el-button>
          <li v-for="item,index in myForm.labels" :key="index">
            标签：{{item.v}}
            <el-button type="text" @click="clickDeleteLabelsSub(index)">删除</el-button>
          </li>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickAdd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

    <!-- start -->
    <el-tab-pane label="修改自动问答" name="five" disabled="disabled">
      <el-form :model="myForm" ref="myForm" label-width="170px">
        <el-form-item label="场景" class="addAdminForm">
          <el-select v-model="myForm.scene" placeholder="请选择" class="select"  style="width: 200px;">
            <el-option label="江苏睿世力" value="1"></el-option>
            <el-option label="广州睿眼" value="2"></el-option>
            <el-option label="豆迈科技" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问题" class="addAdminForm">
          <el-input v-model="myForm.question"></el-input>
        </el-form-item>
        <el-form-item label="答复-文字/图片/视频" class="addAdminForm">
          <el-input v-model="myForm.answerfilesub"></el-input>
          <el-button type="text" @click="clickAddSub()">增加</el-button>
          <li v-for="item,index in myForm.answerfile" :key="index">
            答复：{{item.v}}
            <el-button type="text" @click="clickDeleteSub(index)">删除</el-button>
          </li>
        </el-form-item>
        <el-form-item label="标签" class="addAdminForm">
          <el-input v-model="myForm.labelssub"></el-input>
          <el-button type="text" @click="clickAddLabelsSub()">增加</el-button>
          <li v-for="item,index in myForm.labels" :key="index">
            标签：{{item.v}}
            <el-button type="text" @click="clickDeleteLabelsSub(index)">删除</el-button>
          </li>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickSave">保存</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- end -->

  </el-tabs>
  </div>
</template>

<script>
import TencentyunCosUploadExcel from '@/components/TencentyunCosUploadExcel.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadExcel
  },
  name: 'MyAutoQaMain',
  data () {
    return {
      activeName: 'first',
      myForm: {
        id:0,
        scene: '1',
        question: '',
        answerfilesub: '',
        answerfile: [],
        labelssub: '',
        labels: []
      },
      // 查询
      keywords: {
        scene: '1',
        question: '',
        labels: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1
    }
  },
  mounted () {
    this.apiGetAutoQaMainNum()
    this.apiGetAutoQaMainList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apiGetAutoQaMainNum()
      this.apiGetAutoQaMainList()
    },
    clickmuban () {
      window.open('https://erp-1256233047.cos.ap-shanghai.myqcloud.com/muban/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF%E8%87%AA%E5%8A%A8%E9%97%AE%E7%AD%94.xlsx')
    },
    changeTencentyunCosUploadExcel (url) {
      this.apiExcelImport('22111101',url)
    },
    clickedit (row) {
      this.myForm.id = row.Id
      this.myForm.scene = row.Scene.toString()
      this.myForm.question = row.Question
      this.myForm.answerfilesub = ''
      this.myForm.answerfile = JSON.parse(row.Answerfile)
      this.myForm.labelssub = ''
      this.myForm.labels = JSON.parse(row.Labels)
      this.activeName = 'five'
    },
    clickAdd () {
      this.apiAddAutoQaMain()
    },
    clickAddSub () {
      this.myForm.answerfile.push({v:this.myForm.answerfilesub})
      this.myForm.answerfilesub = ''
    },
    clickDeleteSub (index) {
      var buflist = []
      for (var j = 0, len = this.myForm.answerfile.length; j < len; j++) {
        if (index != j) {
          buflist.push(this.myForm.answerfile[j])
        }
      }
      this.myForm.answerfile = buflist
    },
    clickAddLabelsSub () {
      this.myForm.labels.push({v:this.myForm.labelssub})
      this.myForm.labelssub = ''
    },
    clickDeleteLabelsSub (index) {
      var buflist = []
      for (var j = 0, len = this.myForm.labels.length; j < len; j++) {
        if (index != j) {
          buflist.push(this.myForm.labels[j])
        }
      }
      this.myForm.labels = buflist
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickdel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelAutoQaMain(row.Id)
      })
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetAutoQaMainNum()
      this.apiGetAutoQaMainList()
    },
    clickSave(){
      this.apiEditAutoQaMain()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetAutoQaMainList()
    },
    apiGetAutoQaMainNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        scene: that.keywords.scene,
        question: that.keywords.question,
        labels: that.keywords.labels
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetAutoQaMainNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetAutoQaMainList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        scene: that.keywords.scene,
        question: that.keywords.question,
        labels: that.keywords.labels
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetAutoQaMainList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddAutoQaMain: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        scene: that.myForm.scene,
        question: that.myForm.question,
        answerfile: JSON.stringify(that.myForm.answerfile),
        labels: JSON.stringify(that.myForm.labels)
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddAutoQaMain, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetAutoQaMainNum()
            that.apiGetAutoQaMainList()

            // 清空添加
            that.myForm.question = ''
            that.myForm.answerfilesub = ''
            that.myForm.answerfile = []
            that.myForm.labelssub = ''
            that.myForm.labels = []
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditAutoQaMain: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.myForm.id,
        scene: that.myForm.scene,
        question: that.myForm.question,
        answerfile: JSON.stringify(that.myForm.answerfile),
        labels: JSON.stringify(that.myForm.labels)
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditAutoQaMain, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetAutoQaMainNum()
            that.apiGetAutoQaMainList()

            // 清空添加
            that.myForm.question = ''
            that.myForm.answerfilesub = ''
            that.myForm.answerfile = []
            that.myForm.labelssub = ''
            that.myForm.labels = []
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelAutoQaMain: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelAutoQaMain, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetAutoQaMainNum()
            that.apiGetAutoQaMainList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelImport: function (exceltype,url) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        exceltype: exceltype,
        fileurl: url
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelImport, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
          that.delaysearch()
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    delaysearch () {
      var that = this
      setTimeout(function () {
        that.clicksearch()
      }, 2000)
    },
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.warntitle {
  margin-left: 65px;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: bold;
  color: rgb(127, 124, 126);
}

.productdata1 {
  padding-bottom: 20px;
}

.productdata2 {
  padding-bottom: 5px;
}

</style>
